import { createContext } from "react";

const UploadDocumentContext = createContext<any>(null);

export default UploadDocumentContext;
